export class PatientStatementFilter {

    InvoiceId?: number = null;
    PatientCode: string = "";
    PatientName: string = "";
    PatientTypeID: number;
    PayerID?: number;
    FromIssueDate: Date;
    CoverageContractId?: number;
    CoverageClassId?: number;
    ToIssueDate: Date;
    PageNo: number;
    RowNo: number;
    constructor() { }
}
